@if (isEditSegment) {
<div class="AddSegmentMain">
  <div class="row-new add-first">
    <div class="col-md-4 col-sm-6 col-lg-4 col-xl-4 col-xs-4 lob-edit-subLob-name">
      <span class="form-inline-new">
        <p class="funding-headers">Funding Segment ID</p>
      </span>
      <p>{{ editSegmentDataSource?.Funding_SegmentID }}</p>
    </div>
    <div class="col-md-4 col-sm-6 col-lg-4 col-xl-4 col-xs-4 lob-edit-subLob-name">
      <span class="form-inline-new">
        <p class="funding-headers">Funding Segment</p>
      </span>
      <input
        Placeholder="Enter Funding Segment"
        (input)="disableAddSegment()"
        [(ngModel)]="fundingSegment"
        class="name-add-input lob-border"
      />
    </div>
  </div>
  <div class="row-new lob-architect-row">
    <div class="col-md-6 col-sm-12 col-lg-6 col-xl-6 col-xs-6 ca-ad-block">
      <span class="form-inline-new">
        <p class="funding-headers funding-headers-architects">Funding Owner</p>
      </span>
      <div class="funding-chip-field lob-border">
        <ng-container class="example-chip-list">
          @if (AddSegmentUpdate.FundingOwner) {
          <mat-form-field
            (click)="focusOnInput('addOwner')"
            class="inline-form-edit funding-names-chip chip-fields"
            floatLabel="never"
          >
            <mat-chip-grid #chipList1>
              @for (owner of AddSegmentUpdate.FundingOwner; track owner) {
              <mat-chip-row class="stk-mat-chip" (removed)="removeOwnerAndDeligate(owner, 'Funding_Owner')">
                <span title="{{ owner.msid }}" style="cursor: pointer;">
                  {{ owner.displayName }}
                </span>
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip-row>
              }
            </mat-chip-grid>
            <input
              #inputAddOwner
              class="funding-chip-input"
              placeholder="Search by Name/Mail"
              [matAutocomplete]="auto"
              (keyup)="keyUpSearch($event)"
              [matChipInputFor]="chipList1"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            />
            <mat-autocomplete
              showPanel="true"
              class="lob-options-list"
              #auto="matAutocomplete"
              (optionSelected)="AddFundingOwner($event, 'Funding_Owner')"
            >
              @for (user of users; track user) {
              <mat-option
                [disabled]="checkExistUser(user, 'Funding_Owner', 'Edit')"
                title="{{ user.msid }}<{{ user.displayName }}>({{ user.mail }})"
                [value]="user"
              >
                {{ user.msid }}<{{ user.displayName }}>({{ user.mail }})
              </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
          }
        </ng-container>
      </div>
    </div>
    <div class="col-md-6 col-sm-12 col-lg-6 col-xl-6 col-xs-6 ca-ad-block">
      <span class="form-inline-new">
        <p class="funding-headers funding-headers-architects">Funding Delegate</p>
      </span>
      <div class="funding-chip-field lob-border">
        <ng-container class="example-chip-list">
          @if (AddSegmentUpdate.FundingSegment) {
          <mat-form-field
            (click)="focusOnInput('addDelegate')"
            class="inline-form-edit funding-names-chip chip-fields"
            floatLabel="never"
          >
            <mat-chip-grid #chipListdel>
              @for (delegate of AddSegmentUpdate.FundingSegment; track delegate) {
              <mat-chip-row class="stk-mat-chip" (removed)="removeOwnerAndDeligate(delegate, 'Funding_Delegate')">
                <span title="{{ delegate.msid }}" style="cursor: pointer;">
                  {{ delegate.displayName }}
                </span>
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip-row>
              }
            </mat-chip-grid>
            <input
              #inputAddDelegate
              class="funding-chip-input"
              placeholder="Search by Name/Mail"
              [matAutocomplete]="auto"
              (keyup)="keyUpSearch($event)"
              [matChipInputFor]="chipListdel"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            />
            <mat-autocomplete
              showPanel="true"
              class="lob-options-list"
              #auto="matAutocomplete"
              (optionSelected)="AddFundingOwner($event, 'Funding_Delegate')"
            >
              @for (user of users; track user) {
              <mat-option
                [disabled]="checkExistUser(user, 'Funding_Delegate', 'Edit')"
                title="{{ user.msid }}<{{ user.displayName }}>({{ user.mail }})"
                [value]="user"
              >
                {{ user.msid }}<{{ user.displayName }}>({{ user.mail }})
              </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
          }
        </ng-container>
      </div>
    </div>
  </div>
  <div class="pull-right add-apply-margin">
    <button
      mat-mdc-raised-button
      (click)="addSegment()"
      [disabled]="disableEditSegment"
      class="add-apply m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size"
    >
      Apply
    </button>
  </div>
</div>
}
